import { push, routerReducer } from 'react-router-redux';

export default () => ({
  actions: { push },
  reducer: routerReducer,
});
